/*
 * @Description:
 * @Date: 2020-07-27 11:25:02
 */
import Vue from "vue";
import Vuex from "vuex";
import getters from "./getters";
import createPersistedState from "vuex-persistedstate";
Vue.use(Vuex);

let modules = {};
const storeContext = require.context('@/store/modules', true, /\.js$/);

storeContext.keys().forEach(modulesItem => {
  modules[modulesItem.replace(/(^\.\/)|(\.js$)/g, '')] = storeContext(
    modulesItem
  ).default;
});

export default new Vuex.Store({
  modules,
  plugins: [createPersistedState({ storage: window.sessionStorage })],
  getters
});
